export enum NotificationType {
    success = 'success',
    warning = 'warning',
    error = 'error',
    info = 'info'
}
